import { login, logout, sdauGetInfo, getInfo } from '@/api/user'
import { getToken, setToken, removeToken, setUserinfo, getUserinfo, removeUserinfo } from '@/utils/auth'

const state = {
  token: getToken(),
  userInfo: getUserinfo(),
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_USERINFO: (state, userInfo) => {
    state.userInfo = userInfo
  },
}

const actions = {
  // user login
  login({ dispatch }, userInfo) {
    const { username, password, uuid, validCode } = userInfo
    return new Promise((resolve, reject) => {
      login({
        username: username,
        password: password,
        uuid: uuid,
        validCode: validCode,
      }).then(res => {
        const data = res
        dispatch('setToken', data).then(() => {
          resolve(data)
        })
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 保存token
  setToken({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit('SET_TOKEN', data.token)
      setToken(data.token)
      resolve(data)
    })
  },

  // 获取用户信息
  setUsrmsg({ dispatch, commit }) {
    return new Promise((resolve, reject) => {
      getInfo().then(res => {
        sdauGetInfo(res.user.userId).then(response => {
          const data = response
          dispatch('saveUsrmsg', data).then(() => {
            resolve(data)
          })
        }).catch(error => {
          commit('SET_USERINFO', '')
          reject(error)
        })
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 保存用户信息
  saveUsrmsg({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit('SET_USERINFO', data.data)
      setUserinfo(data.data)
      resolve(data)
    })
  },
  // 退出登录
  logout({ dispatch, commit }) {
    return new Promise((resolve, reject) => {
      logout().then(() => {
        dispatch('resetToken').then(() => {
          resolve()
        })
        commit('SET_USERINFO', '')
        removeUserinfo()
      }).catch(error => {
        reject(error)
      })
    })
  },

  // remove token
  resetToken({ commit, state, dispatch }) {
    return new Promise(resolve => {
      commit('SET_TOKEN', '')
      removeToken()
      removeUserinfo()
      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
